"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InterviewByDateFilter = void 0;
/*
 * Copyright 2023, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const react_datepicker_1 = __importDefault(require("react-datepicker"));
const LodashExtensions_1 = require("chaire-lib-common/lib/utils/LodashExtensions");
/**
 * Date picker input for interview creation date filter
 */
const InterviewByDateFilter = ({ t, column: { filterValue, setFilter } }) => {
    const [startDate, setStartDate] = react_1.default.useState(!(0, LodashExtensions_1._isBlank)(filterValue) && filterValue.value && filterValue.value.length === 2
        ? new Date(filterValue.value[0] * 1000)
        : null);
    const [endDate, setEndDate] = react_1.default.useState(!(0, LodashExtensions_1._isBlank)(filterValue) && filterValue.value && filterValue.value.length === 2
        ? new Date(filterValue.value[1] * 1000) // Filter dates are saved in seconds, but JavaScript expects dates in ms.
        : null);
    return (react_1.default.createElement("div", { style: { display: 'flex', alignItems: 'center' } },
        react_1.default.createElement("label", { htmlFor: 'interviewDateSearchInput' }, t('admin:interviewByDateFilter:title')),
        react_1.default.createElement(react_datepicker_1.default, { className: 'apptr__form-input input-date-picker input-large', shouldCloseOnSelect: false, disabledKeyboardNavigation // Otherwise current day of month always looks selected, which is confusing
            : true, isClearable: true, selectsRange: true, dateFormat: "yyyy-MM-dd", selected: startDate, startDate: startDate, endDate: endDate, onChange: (dates) => {
                if ((0, LodashExtensions_1._isBlank)(dates)) {
                    setStartDate(null);
                    setEndDate(null);
                    setFilter(null);
                    return;
                }
                const [start, end] = dates;
                setStartDate(start);
                setEndDate(end);
                if (!(0, LodashExtensions_1._isBlank)(start) && !(0, LodashExtensions_1._isBlank)(end)) {
                    start.setHours(0, 0, 0); // Start of day
                    end.setHours(23, 59, 59); // End of day
                    // JavasScript dates are given in milliseconds, but the database filters expect seconds.
                    setFilter({ value: [Math.floor(start.valueOf() / 1000), Math.floor(end.valueOf() / 1000)] });
                }
                else if ((0, LodashExtensions_1._isBlank)(start) && (0, LodashExtensions_1._isBlank)(end)) {
                    setFilter(null);
                }
                else {
                    // if we only have one of the dates, do nothing. Wait until we get the full date range to apply filter.
                }
            }, placeholderText: t('admin:interviewByDateFilter:placeholder') })));
};
exports.InterviewByDateFilter = InterviewByDateFilter;
exports.default = (0, react_i18next_1.withTranslation)(['admin', 'main'])(exports.InterviewByDateFilter);
//# sourceMappingURL=InterviewByDateFilter.js.map